var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top-bar',[_vm._v(_vm._s(_vm.domainLabel))]),_c('back-button',{on:{"click":function($event){return _vm.clickBackButton()}}}),_c('chapter-survey')],1)}
var staticRenderFns = []

export { render, staticRenderFns }